import { render, staticRenderFns } from "./agencyPointsDetails.vue?vue&type=template&id=45246e85&scoped=true&"
import script from "./agencyPointsDetails.vue?vue&type=script&lang=js&"
export * from "./agencyPointsDetails.vue?vue&type=script&lang=js&"
import style0 from "./agencyPointsDetails.vue?vue&type=style&index=0&id=45246e85&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45246e85",
  null
  
)

export default component.exports